import type React from 'react';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  children: (theme: Theme) => React.ReactElement;
};
const CdsThemeProvider = ({ children }: Props) => {
  const theme = useTheme();
  return children(theme);
};

export default CdsThemeProvider;
